import React, {type ReactNode} from "react";
import styles from "./ErrorText.module.scss"

interface  ErrorTextProps{
  children: ReactNode;
}
const ErrorText: React.FC<ErrorTextProps>= ({ children }) => {
  return <p className={styles.validation_text}>{children}</p>;
};

export default ErrorText;
